import type { FC, MouseEventHandler } from "react";
import { IconMinus } from "@web-monorepo/dds-icons";
import styles from "./MinusButton.module.css";
import { clsx } from "clsx";

type Props = {
  className?: string;
  onClick: MouseEventHandler<HTMLButtonElement>;
};

const MinusButton: FC<Props> = ({ className, onClick }) => (
  <button className={clsx(styles.minusButton, className)} onClick={onClick} aria-label="Remove media">
    <IconMinus size="s" fill={"dt_content_primary"} />
  </button>
);

export default MinusButton;
